import { MyContactForm } from "./MyContactForm"
import { MyEducation } from "./MyEducation"
import { MyExperience } from "./MyExperience"
import { MyHeader } from "./MyHeader"
import { MyHero } from "./MyHero"
import { MyLocation } from "./MyLocation"
import { MyOverview } from "./MyOverview"
import { MyProjects } from "./MyProjects"
import { MySkill } from "./MySkill"

export const My = {
  ContactForm: MyContactForm,
  Education: MyEducation,
  Experience: MyExperience,
  Header: MyHeader,
  Hero: MyHero,
  Location: MyLocation,
  Overview: MyOverview,
  Projects: MyProjects,
  Skill: MySkill,
}
